<script lang="ts" module>
  import type { CatalogView } from "./catalogStore.svelte";

  /**
   * Density. Three states rather than a slider: the difference that matters is how much chrome each
   * item carries, and that is a choice between layouts, not a continuum.
   */
  export const VIEWS: { value: CatalogView; icon: string; label: string }[] = [
    { value: "cozy", icon: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z", label: "catalog.viewCozy" },
    {
      value: "compact",
      icon: "M4 4h4v4H4zM10 4h4v4h-4zM16 4h4v4h-4zM4 10h4v4H4zM10 10h4v4h-4zM16 10h4v4h-4zM4 16h4v4H4zM10 16h4v4h-4zM16 16h4v4h-4z",
      label: "catalog.viewCompact",
    },
    { value: "list", icon: "M4 6h16M4 12h16M4 18h16", label: "catalog.viewList" },
  ];

  /**
   * How a grid lays out for the chosen view. The column counts are the whole difference between
   * scanning a folder and paging through it in a Revit side panel.
   *
   * Shared by the cloud catalog and a local folder deliberately: they are the same grid of the same
   * kind of thing, and a density that meant one layout in one and another in the other would be a
   * setting that appears to do different things depending on which tab you are on.
   */
  export function gridClassFor(view: CatalogView): string {
    switch (view) {
      case "list":
        return "flex flex-col gap-1.5";
      case "compact":
        return "grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-2";
      default:
        return "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3";
    }
  }
</script>

<script lang="ts">
  import { t } from "@/i18n/index.svelte";

  let { value, onchange }: { value: CatalogView; onchange: (view: CatalogView) => void } = $props();
</script>

<div class="flex items-center rounded-control border border-line overflow-hidden shrink-0">
  {#each VIEWS as v (v.value)}
    <button
      class="p-2 transition-colors {value === v.value
        ? 'bg-accent text-white'
        : 'text-ink-muted hover:text-accent'}"
      aria-label={t(v.label)}
      aria-pressed={value === v.value}
      title={t(v.label)}
      onclick={() => onchange(v.value)}
    >
      <svg viewBox="0 0 24 24" class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.6">
        <path d={v.icon} />
      </svg>
    </button>
  {/each}
</div>
